export const CDN = process.env.REACT_APP_CDN;

/*
 * Account Admin
 */

export const ACCOUNT_API = process.env.REACT_APP_ACCOUNT_ADMIN_API + '/api';

// Accounts
export const ACCOUNT_API_ROUTE = ACCOUNT_API + '/Accounts';
export const ACCOUNT_API_GET_ACCOUNT = ACCOUNT_API_ROUTE + '/GetAccount';
export const ACCOUNT_API_GET_ACCOUNT_LIST =
	ACCOUNT_API_ROUTE + '/GetAccountList';
export const ACCOUNT_API_GET_ACCOUNTS_BY_COMPANY =
	ACCOUNT_API_ROUTE + '/GetAccountsByCompanyId';
export const ACCOUNT_API_GRANT_ACCESS = ACCOUNT_API_ROUTE + '/GrantAccess';
export const ACCOUNT_API_REVOKE_ACCESS = ACCOUNT_API_ROUTE + '/RevokeAccess';
export const ACCOUNT_API_MARK_REVIEWED = ACCOUNT_API_ROUTE + '/MarkReviewed';
export const ACCOUNT_API_LOCK = ACCOUNT_API_ROUTE + '/Lock';
export const ACCOUNT_API_UNLOCK = ACCOUNT_API_ROUTE + '/Unlock';
export const ACCOUNT_API_ASSIGN_AND_MARK_REVIEWED =
	ACCOUNT_API_ROUTE + '/AssignAccountToCompanyAndMarkAsReviewed';
export const SUBSCRIPTIONS_INVITE_USER = ACCOUNT_API_ROUTE + '/InviteUser';
export const ACCOUNT_API_RESEND_VERIFICATION_EMAIL =
	ACCOUNT_API_ROUTE + '/ResendVerificationEmail';
export const ACCOUNT_API_CONNECT_TO_HUBSPOT =
	ACCOUNT_API_ROUTE + '/ConnectAccountToHubSpot';

// System Entities
export const SYSTEM_ENTITIES_ROUTE = ACCOUNT_API + '/systementity';
export const SYSTEM_ENTITIES_GET_LIST =
	SYSTEM_ENTITIES_ROUTE + '/GetSystemEntities';
export const SYSTEM_ENTITIES_GET_BYCOMPANY =
	SYSTEM_ENTITIES_ROUTE + '/GetSystemEntitiesByCompanyId';
export const SYSTEM_ENTITIES_GET_ENTITY =
	SYSTEM_ENTITIES_ROUTE + '/GetSystemEntity';
export const SYSTEM_ENTITIES_CREATE_ENTITY =
	SYSTEM_ENTITIES_ROUTE + '/CreateSystemEntity';
export const SYSTEM_ENTITIES_UPDATE_ENTITY =
	SYSTEM_ENTITIES_ROUTE + '/UpdateSystemEntity';

// Developer
export const DEVELOPER_API_ROUTE = ACCOUNT_API + '/developer';
export const DEVELOPER_API_GET_ACCOUNT_AWAITING_HUBSPOT_SYNC =
	DEVELOPER_API_ROUTE + '/GetAccountsAwaitingHubSpotSync';
export const DEVELOPER_API_SYNC_ACCOUNTS_TO_HUBSPOT =
	DEVELOPER_API_ROUTE + '/SyncAccountsToHubSpot';
export const DEVELOPER_API_SYNC_ACCOUNT_FROM_FUSIONAUTH =
	DEVELOPER_API_ROUTE + '/SyncAccountFromFusionAuth';
export const DEVELOPER_API_IMPORT_YOUNIUM_ACCOUNTS =
	DEVELOPER_API_ROUTE + '/ImportYouniumAccounts';
export const DEVELOPER_API_GET_UNUSED_SUBSCRIPTIONS =
	DEVELOPER_API_ROUTE + '/GetUnusedSubscriptions';
export const DEVELOPER_API_SYNC_ADMIN_ACCOUNTS =
	DEVELOPER_API_ROUTE + '/SyncAdminAccountsFromFusionAuth';

// Activities
export const ACCOUNT_API_ACTIVITIES = ACCOUNT_API + '/activities';
export const ACCOUNT_API_ADMINLOG = ACCOUNT_API_ACTIVITIES + '/adminlog';
export const ACCOUNT_API_EOD_INDEX_LOG = ACCOUNT_API_ACTIVITIES + '/endofday';

//Admin Users
export const ADMIN_ACCOUNT_API_ROUTE = ACCOUNT_API + '/Admins';
export const ADMIN_ACCOUNT_DELETE = ADMIN_ACCOUNT_API_ROUTE + '/deleteadmin';

//Products
export const REGISTRATION_API_ROUTE = ACCOUNT_API + '/Registration';

//Subscriptions
export const SUBSCRIPTIONS_API_ROUTE = ACCOUNT_API + '/Subscriptions';
export const SUBSCRIPTIONS_GET_BY_COMPANY =
	SUBSCRIPTIONS_API_ROUTE + '/GetSubscriptionsByCompanyId';
export const SUBSCRIPTIONS_GET_BY_SUBSCRIBER =
	SUBSCRIPTIONS_API_ROUTE + '/GetSubscriptions';
export const SUBSCRIPTIONS_GET_BY_APPLICATION =
	SUBSCRIPTIONS_API_ROUTE + '/GetSubscriptionsByApplicationId';
export const SUBSCRIPTIONS_GET_APPLICATIONS =
	SUBSCRIPTIONS_API_ROUTE + '/GetApplications';
export const SUBSCRIPTIONS_CANCEL_SUBSCRIPTION =
	SUBSCRIPTIONS_API_ROUTE + '/CancelSubscription';
export const SUBSCRIPTIONS_ASSIGN_SEAT =
	SUBSCRIPTIONS_API_ROUTE + '/AssignSeat';
export const SUBSCRIPTIONS_DELETE_SUBSCRIPTION =
	SUBSCRIPTIONS_API_ROUTE + '/DeleteSubscription';
export const SUBSCRIPTIONS_GET_PROVIDERS =
	SUBSCRIPTIONS_API_ROUTE + '/GetProviders';
export const SUBSCRIPTIONS_GET_COMPANY_BLACKLISTED_BY =
	SUBSCRIPTIONS_API_ROUTE + '/GetCompanyBlacklistedBy';

//Subscription Bundles
export const BUNDLES_GET_BUNDLE = SUBSCRIPTIONS_API_ROUTE + '/GetBundle';
export const BUNDLES_GET_BY_COMPANY =
	SUBSCRIPTIONS_API_ROUTE + '/GetBundlesByCompanyId';
export const BUNDLES_CREATE_BUNDLE = SUBSCRIPTIONS_API_ROUTE + '/CreateBundle';
export const BUNDLES_UPDATE_BUNDLE = SUBSCRIPTIONS_API_ROUTE + '/UpdateBundle';
export const BUNDLES_DELETE_BUNDLE = SUBSCRIPTIONS_API_ROUTE + '/DeleteBundle';
export const BUNDLES_CANCEL_BUNDLE = SUBSCRIPTIONS_API_ROUTE + '/CancelBundle';

//Event Log
export const ACCOUNT_API_EVENT_LOG = ACCOUNT_API + '/EventLog';

//Companies
export const ACCOUNT_API_COMPANIES = ACCOUNT_API + '/Companies';
export const COMPANIES_UPDATE_COMPANY =
	ACCOUNT_API_COMPANIES + '/UpdateCompany';
export const COMPANIES_DELETE_COMPANY =
	ACCOUNT_API_COMPANIES + '/DeleteCompany';
export const COMPANIES_ASSIGN_SEAT =
	ACCOUNT_API_COMPANIES + '/AssignAccountToCompany';

// Provider access export
export const PROVIDER_ACCESS_LOGS_API_ROUTE = ACCOUNT_API + '/ProviderAccess';
export const PROVIDER_ACCESS_GET_USER_LEVEL_ACCESS =
	PROVIDER_ACCESS_LOGS_API_ROUTE + '/GetProviderAccessForUsers';
export const PROVIDER_ACCESS_EXPORT_USER_LEVEL_ACCESS =
	PROVIDER_ACCESS_LOGS_API_ROUTE + '/ExportProviderAccessForUsers';

export const PROVIDER_ACCESS_GET_COMPANY_LEVEL_ACCESS =
	PROVIDER_ACCESS_LOGS_API_ROUTE + '/GetProviderAccessForCompanies';
export const PROVIDER_ACCESS_EXPORT_COMPANY_LEVEL_ACCESS =
	PROVIDER_ACCESS_LOGS_API_ROUTE + '/ExportProviderAccessForCompanies';

export const GET_DUPLICATE_HUBSPOTID_ACCOUNTS =
	ACCOUNT_API_ROUTE + '/GetAccountsWithDuplicateHubspotIds';
export const MARK_PRIMARY_ACCOUNT = ACCOUNT_API_ROUTE + '/MarkPrimary';
export const MARK_NOT_PRIMARY_ACCOUNT = ACCOUNT_API_ROUTE + '/MarkNotPrimary';
